<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-input
                    v-model="form.admin_name"
                    placeholder="操作人"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-select
                    v-model="form.type"
                    placeholder="操作类型"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in baseInfo.search_ops.types"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.status"
                    placeholder="状态"
                    style="width: 150px"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="item in baseInfo.search_ops.status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="datetimerange"
                    :default-time="['00:00:00', '23:59:59']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd; height: 150px">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <span>账户情况</span>
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="primary"
            @click="show(1)"
            >充值</el-button
          >
          <el-button
            slot="trigger"
            style=""
            size="mini"
            type="success"
            @click="show(2)"
            >提现</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="baseInfo.base"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="baseInfo.base"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="bzj_money"
              label="一手商家子账户金额"
            ></el-table-column>
            <!--                        <el-table-column align="center" prop="need_cash" label="需提现金额"></el-table-column>-->
            <el-table-column
              align="center"
              prop="gz_money"
              label="平安挂账子账户-可充值金额"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <span>日志</span>
          <el-button
            slot="trigger"
            style="margin-left: auto"
            size="mini"
            type="success"
            @click="exportExcel"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            :cell-class-name="addColor"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="admin_name"
              label="操作人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pa_cash_log_type"
              label="操作类型"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="money"
              label="金额"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="pa_cash_log_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="remark"
              label="备注"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[10, 50, 100, 200, 500, 1000]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <cash-and-recharge
        :url="action"
        :action_type="action_type"
        :base="baseInfo.base"
        @onCloseDialog="onCloseDialog"
      ></cash-and-recharge>
    </div>
  </div>
</template>

<script>
import CashAndRecharge from "./components/CashAndRecharge";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    CashAndRecharge,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchBaseInfo();
    });
  },
  data() {
    return {
      resData: {},
      baseInfo: {},
      form: {
        create_time: this.defaultDate(),
        pagesize: 100,
      },
      loading: false,
      tableLoading: false,
      url: "/erp/PaCashLog/logList",
      action: "",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      logcurPage: 1,
      logInfo: {},
      multipleSelection: [],
      payVisible: false,
      action_type: 0,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    show(type) {
      this.action_type = type;
      if (type == 1) {
        this.action = "/erp/PaCashLog/recharge";
      } else {
        this.action = "/erp/PaCashLog/cash";
      }
      this.$nextTick(() => {
        this.payVisible = true;
      });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 3);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    addColor({ row, column, columnIndex }) {
      // if (columnIndex === 15) {
      //     return 'blue-cell';
      // }
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    onCloseDialog(e) {
      this.payVisible = false;
      this.fetchData();
      this.fetchBaseInfo();
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    fetchBaseInfo(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http
        .post("/erp/PaCashLog/getBaseInfo", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$set(this.baseInfo, "base", res.data.data.base);
            this.$set(this.baseInfo, "search_ops", res.data.data.search_ops);
          }
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
      }
      this.multipleSelection = multipleSelection;
    },

    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/pacashlog/PaCashLogList.vue